import React from "react";

// reactstrap components
import { Container, Col } from "reactstrap";

// core components

function PrecEditionHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });
  return (
    <>
      <div
        className="page-header clear-filter page-header-small"
        filter-color="blue"
      >
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" + require("assets/img/old-gala.jpg").default + ")",
          }}
          ref={pageHeader}
        ></div>
        <Container>
          <div className="photo-container">
            <Col className="ml-auto" md="1">
            <img alt="..." src={require("assets/img/logo-nuit.png").default}></img>
            </Col>
          </div>
          <h3 className="title">Les Nuits INSA</h3>
{/*           <p className="category">Depuis des années ...</p> */}
          <div className="content">
            <div className="social-description">
              <h2>16</h2>
              <p>éditions</p>
            </div>
            <div className="social-description">
              <h2>900</h2>
              <p>personnes</p>
            </div>
            <div className="social-description">
              <h2>1</h2>
              <p>soirée</p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default PrecEditionHeader;
